@if (form && subTopic.action === SUBTOPIC_ACTIONS.SHOW_FORM) {
  <form-contact
    [form]="form"
    [countries$]="countries$"
    [businessTypes$]="businessTypes$"
    [stateRegions$]="stateRegions$"
    (_onSubmit)="submit()"
  ></form-contact>
}

@if (subTopic.action === SUBTOPIC_ACTIONS.REQUIRE_LOGIN) {
  <request-login></request-login>
}

@if (subTopic.action === SUBTOPIC_ACTIONS.CONTENT) {
  <div [innerHTML]="subTopic.content"></div>
}
